import { useCallback, useRef } from 'react';

import { useDialogs } from '@confluence/dialogs/entry-points/useDialogs.ts';

import { PagePdfExportModal } from '../../entry-points/PagePdfExportModal.ts';

import { useCreatePagePdfExportTask } from './useCreatePagePdfExportTask.ts';

export type PagePdfExportPrintShortcutHandler = (pageId: string) => Promise<boolean>;

export const usePagePdfExportPrintShortcut = (): PagePdfExportPrintShortcutHandler => {
	const { createAndResolve } = useCreatePagePdfExportTask();
	const { showModal } = useDialogs();
	const isCreatingRef = useRef(false);

	return useCallback(
		async (pageId: string): Promise<boolean> => {
			if (isCreatingRef.current) {
				return true;
			}

			isCreatingRef.current = true;

			try {
				const decision = await createAndResolve(pageId);

				switch (decision.type) {
					case 'legacy':
						return false;
					case 'modal':
						showModal(PagePdfExportModal, {
							contentId: pageId,
							exportTaskId: decision.exportTaskId,
							source: 'print-shortcut',
						});
						return true;
					case 'error':
						showModal(PagePdfExportModal, {
							contentId: pageId,
							exportTaskId: null,
							source: 'print-shortcut',
						});
						return true;
				}
			} finally {
				isCreatingRef.current = false;
			}
		},
		[createAndResolve, showModal],
	);
};
